import FluxUtils from 'flux/utils';

import WebAppsActions from 'sharedreact/actions/WebAppsActions';
import AppLauncherSlideOut from 'sharedreact/components/AppLauncherSlideOut';
import SettingsStore from 'sharedreact/stores/SettingsStore';
import WebAppsStore from 'sharedreact/stores/WebAppsStore';
import asFunctional from 'sharedreact/components/asFunctional';

type State = ConstructorParameters<typeof AppLauncherSlideOut>[0];

function getStores () {
  return [
    SettingsStore,
    WebAppsStore
  ];
}

function calculateState (prevState?: State): State {
  return {
    apps: WebAppsStore.getItems(),
    allAppsUrl: WebAppsStore.getAllAppsUrl(),
    language: SettingsStore.getLanguage(),
    show: WebAppsStore.getState().isSlideOutVisible,
    currentWorkspace: WebAppsStore.getCurrentWorkspace(),
    onClose: WebAppsActions.hide
  };
}

export default FluxUtils.Container.createFunctional(
  asFunctional(AppLauncherSlideOut),
  getStores,
  calculateState
);
